// extracted by mini-css-extract-plugin
export default {"authenticationModal":"Modal-module__authenticationModal___UZzlz"};